import React from 'react';
import styles from './header.module.css';

class PubHeader extends React.Component {
  render () {
    return (
      <header className={styles.header}>
        <div className="inner">
          <div className={styles.clear}>
            <div className={styles.logo}  id="app-logo"/>
            <div className={styles.app}>Самозанятые</div>
          </div>
        </div>
      </header>
    )
  }
}

export default PubHeader;
